const skills = {
  1: [
    {
      title: "Android",
      level: 8
    },
    {
      title: "XML",
      level: 9
    },

    {
      title: "Java",
      level: 6
    },
    {
      title: "Kotlin",
      level: 4
    },

    {
      title: "Flutter",
      level: 5
    },
    {
      title: "Dart",
      level: 4
    },
    {
      title: "ReactNative",
      level: 5
    },
    {
      title: "Figma",
      level: 4
    }
  ],
  2: [
   
    {
      title: "Javascript",
      level: 5
    },
    {
      title: "Firebase",
      level: 5
    },
    {
      title: "Git",
      level: 6
    },
 
  
  ]
};

export default skills;
